const getCompetitionTiming = (competition) => {
  if (!competition) return { hasStarted: false, hasEnded: false, hasRegistrationEnded: false };

  const now = Date.now();

  // Utility to normalize a date string to UTC format
  const toUTCDate = (dateStr) => {
    if (!dateStr) return null;
    // If there's no 'T', replace the first space with 'T'
    let normalized = dateStr.includes('T') ? dateStr : dateStr.replace(' ', 'T');
    // Append 'Z' if it's not there already
    if (!normalized.endsWith('Z')) {
      normalized += 'Z';
    }
    return new Date(normalized);
  };

  const startTime = competition.start ? toUTCDate(competition.start).getTime() : null;
  const endTime = competition.end ? toUTCDate(competition.end).getTime() : null;
  const registrationEndTime = competition.registrationEnd ? toUTCDate(competition.registrationEnd).getTime() : null;

  const hasStarted = startTime ? now >= startTime : false;
  const hasEnded = endTime ? now >= endTime : false;
  const hasRegistrationEnded = registrationEndTime ? now >= registrationEndTime : false;

  return { hasStarted, hasEnded, hasRegistrationEnded };
};

export default getCompetitionTiming;
